import { render, staticRenderFns } from "./events-list.html?vue&type=template&id=61e36688&scoped=true&external"
import script from "./events-list.js?vue&type=script&lang=js&external"
export * from "./events-list.js?vue&type=script&lang=js&external"
import style0 from "./events-list.scss?vue&type=style&index=0&id=61e36688&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e36688",
  null
  
)

export default component.exports